import { React, useRef, useEffect, useState } from "react";
import { API_BASE_URL } from "../../environment";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import NewTopNavBar from "../NewTopNavBar";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { filterDataByUserTags } from "../../utils/commons";
import OpenPlatformNavbar from "../OpenPlatformNavbar";
const OpenPltformSearchLandingPageNew = () => {
  const [page, setPage] = useState(0);
  const [filterData, setFilterData] = useState([]);
  // const [spnierLoading, setSpnierLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const sentinelRef = useRef(null);
  const [postTitles, setPostTitles] = useState([]);
  const navigate = useNavigate();
  const [collaps, setCollaps] = useState(true);
  const [isDisplay, setIsDisplay] = useState(true);
  let bearerToken = "";
  const handleInputChange = (e) => {
    // console.log(process.env.REACT_APP_API_ENDPOINT);
    const inputQuery = e.target.value;

    setQuery(inputQuery);
  };
  const handleSearch = (e) => {
    e.preventDefault(); // Prevent form submission
    if (query == "") {
      toast.error("Enter text to perform a search.");
      return;
    } else if (query.length == 1) {
      toast.error("Please provide additional text to refine your search.");
      return;
    }
    localStorage.removeItem("subcategoryId");
    localStorage.removeItem("catagoryId");
    navigate(`/results`);
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (query.trim() !== "") {
        fetchPostTitles();
      } else {
        setPostTitles([]);
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [query]);
  //
  const fetchPostTitles = () => {
    if (query) {
      let request = {
        method: "GET",
        url: `${API_BASE_URL}/wp-json/wp/v2/posts?search=${query}&per_page=100`,
      };
      const startTime = new Date();

      fetch(
        `${API_BASE_URL}/wp-json/wp/v2/posts?search=${query}&per_page=100`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          const endTime = new Date();
          // logApiRequest(request, response, startTime, endTime);
          return response.json(); // Return the parsed JSON to the next .then()
        })
        .then((data) => {
          // Assuming the response contains post titles as an array
          console.log("data71=", data);
          data = filterDataByUserTags(data);
          const normalPost = [];
          const filterPosts = data.filter((data) => {
            console.log("50=", data.title.rendered);
            if (
              data.title.rendered.toLowerCase().includes(query.toLowerCase())
            ) {
              return data;
            } else {
              normalPost.push(data);
            }
          });
          filterPosts.push(...normalPost);
          setPostTitles(filterPosts);
          console.log(data);
          setIsDisplay(true);
        })
        .catch((error) => {
          console.error(error);
          localStorage.removeItem("jwt_token");
          localStorage.removeItem("tags");
          // logApiRequest(request, error.response || { status: error.message });
          navigate("/");
        });
    } else {
      // Clear post titles if the query is empty
      setPostTitles([]);
    }
  };
  const gotToArticlePage = (postId) => {
    // localStorage.setItem("postId", postId)
    navigate(`/single-article?id=${postId}`);
  };
  const catagoryHandle = (catId, catName) => {
    // alert(catId)
    localStorage.setItem("catagoryId", catId);
    localStorage.setItem("categoryName", catName);
    // navigate('/category-posts')
    navigate("/subcategory");
  };
  const fetchCategories = (page) => {
    setLoading(true);

    axios
      .get(
        `${API_BASE_URL}/wp-json/custom-category/v1/get-parent-categories?page=${page}`
      )
      .then((response) => {
        //
        axios
          .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`)
          .then((res) => {
            const whitlistUrl = res.data.filter((res) => {
              if (res.url.includes(window.location.origin)) {
                return res;
              }
            });

            console.log("whitelist url=", whitlistUrl);

            const parentCategory = response.data.filter((data) => {
              if (
                data.parent == 0 &&
                whitlistUrl[0].category.includes(data.id) &&
                whitlistUrl[0].toggle_status == true
              ) {
                return data;
              }
            });

            // const parentCategory = response.data.filter((data) => {
            //   // console.log('line279=', whitlistUrl[0].category.includes(data.id))
            //   if (data.parent == 0) {
            //     return data;
            //   }
            // });

            console.log("283=", parentCategory);
            // setLoading(false)
            setFilterData((prevPosts) => [...prevPosts, ...parentCategory]);
            // setCategoriesWithCount(response.data);
            // setCategoriesWithCount(parentCategory);
            // setSpnierLoading(spnierLoading ? false : true)
            // setSpnierLoading(false);
            // console.log("spinerloading=", spnierLoading);
            // alert('alert2')
          })
          .catch((err) => {
            console.log(err);
            // alert('alert3')
          });
        //
        // setFilterData((prevPosts) => [...prevPosts, ...res.data]);
        // setSpnierLoading(false);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    console.log("line35", page);
    if (page != 0) {
      fetchCategories(page);
    }
  }, [page]);
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setPage((prevPage) => prevPage + 1);
        }
      });
    },
    { threshold: 1 }
  );

  useEffect(() => {
    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);

  // Infinite Scroll End
  const mainDivClick = () => {
    setIsDisplay(false);
    // document.getElementById("suggestionId").style.display = "none";
  };
  localStorage.setItem("searchQuery", query);
  return (
    <>
      <div onClick={mainDivClick}>
        <OpenPlatformNavbar />
        <div className="w-100 position-relative">
          {/* <div className='p-4'>
              <button style={{ border: 'none' }} onClick={CollapseSidbarBtn} className="  order-1 order-lg-0 me-4 me-lg-0 "><i className="fas fa-bars" ></i></button>
            </div> */}
          <div className="w-100 pt-5 fw-bold">
            <div className="d-flex flex-column justify-content-center">
              {/* <h2 className='fw-bold'>Knowledge Base</h2> */}
              <p style={{ fontSize: "28px" }}>Search for Articles</p>
            </div>
          </div>
          <div className="search-back w-100">
            <form
              role="search"
              method="get"
              className="search-form mb-5"
              onSubmit={handleSearch}
            >
              <label style={{ flex: "1", background: "#ffffff59" }}>
                <input
                  type="text"
                  className="search-field"
                  placeholder="Search..."
                  value={query}
                  onChange={handleInputChange}
                />
              </label>
              <button type="submit" className="search-submit">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z"
                  />
                </svg>
              </button>

              {/* <SearchResults results={suggestions} /> */}
            </form>
            {/* <div>
                <img src={AiImg} alt="" />
              </div> */}
          </div>
          {console.log("suggestion-list", postTitles)}
          {query.trim() !== "" && (
            <ul
              id={isDisplay ? "suggestionBlock" : "suggestionNone"}
              className={collaps ? "suggestion-list2" : "suggestion-list"}
            >
              {postTitles
                ? postTitles.map((title, index) => (
                    <div
                      className="p-0 m-0 suggestion-link"
                      onClick={() => gotToArticlePage(title.id)}
                    >
                      <li key={index} className="m-0 suggestion">
                        {title.title.rendered}
                      </li>
                    </div>
                  ))
                : ""}
            </ul>
          )}
        </div>
        <div className="overflow-auto">
          <div className="container">
            <div className="row g-0">
              {filterData?.length > 0 ? (
                filterData?.map((val) => {
                  // console.log("val=", val)
                  return (
                    // <div className=" col-12 col-md-4 col-sm-6 col-xl-3  mb-3 pe-2">

                    // </div>
                    <div
                      //   style={{ height: "70px" }}
                      onClick={() => catagoryHandle(val.id, val.name)}
                      className="col-sm-6 col-md-6 col-lg-4"
                    >
                      <div className="d-flex  border m-2 mt-0  categoryBoxMainDiv">
                        <img
                          className="categoryImgBox"
                          height={80}
                          width={80}
                          src={val.image}
                          alt=""
                        />
                        {/* <div className='categoryImgBox '>

                      </div> */}
                        <div>
                          <div className="categoryNameDiv">
                            <p className="mb-0 fw-bold">
                              {val.name.length > 30
                                ? `${val.name.slice(0, 30)}...`
                                : val.name}
                            </p>
                          </div>
                          <div className="d-flex ">
                            <p className="mb-0">
                              {val.unique_authors_count}{" "}
                              {val.unique_authors_count <= 1
                                ? "Author"
                                : "Authors"}
                            </p>
                            <p className="ps-4 mb-0">
                              {val.post_count}{" "}
                              {val.post_count <= 1 ? "Article" : "Articles"}{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="d-flex justify-content-center ">
                  {/* <div>Data not found</div> */}
                  {/* {console.log("520")} */}
                  <Spinner />
                </div>
              )}
            </div>
          </div>
          <div ref={sentinelRef} />
          {loading && filterData?.length > 0 ? (
            <div className="d-flex justify-content-center mb-5">
              {" "}
              <Spinner />{" "}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default OpenPltformSearchLandingPageNew;
